import { render, staticRenderFns } from "./KoenigTheoremViz.vue?vue&type=template&id=2ddaa122&scoped=true"
import script from "./KoenigTheoremViz.vue?vue&type=script&lang=js"
export * from "./KoenigTheoremViz.vue?vue&type=script&lang=js"
import style0 from "./KoenigTheoremViz.vue?vue&type=style&index=0&id=2ddaa122&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddaa122",
  null
  
)

export default component.exports